import { render, staticRenderFns } from "./SearchFilterSummary.vue?vue&type=template&id=688adb6c&scoped=true"
import script from "./SearchFilterSummary.vue?vue&type=script&lang=js"
export * from "./SearchFilterSummary.vue?vue&type=script&lang=js"
import style0 from "./SearchFilterSummary.vue?vue&type=style&index=0&id=688adb6c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "688adb6c",
  null
  
)

export default component.exports